require("./vendor/cookie-consent/cookie-consent.js")
import findApp from "./findApp";

window.openTawk = () => {
    window.Tawk_API = window.Tawk_API || {};

    if (!window.Tawk_API.onLoaded) {
        const div = document.createElement("div");
        div.setAttribute("style", "background: rgba(0,0,0,0.2); position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999");
        div.id = "ovform-tawk-overlay";
        document.body.appendChild(div);


        window.Tawk_API.onBeforeLoad = function(){

            setTimeout(() => {
                document.getElementById("ovform-tawk-overlay")?.remove();
            }, 1000);

            // remove element from dom
            // div.setAttribute("style", "display: none");

            window.Tawk_API.maximize();
        };

        var s1=document.createElement("script")
        var s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/620d21001ffac05b1d7a3745/1fs1khqi2';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode?.insertBefore(s1,s0);

    } else {
        // document.getElementById("ovform-tawk-overlay")?.remove();
        // div.setAttribute("style", "display: none");
        window.Tawk_API.maximize();
    }
};


function saveUtmValues() {
    // save utm values to localstorage
    const utmParams = new URLSearchParams(window.location.search);
    console.log("utmParams",window.location.search, utmParams)
    const utmValues = {};
    for (const [key, value] of utmParams) {
        if (key.startsWith("utm_")) {
            utmValues[key] = value;
        }
    }
    if (Object.keys(utmValues).length !== 0) {
        localStorage.setItem("utmValues", JSON.stringify(utmValues));
    }
}

saveUtmValues();

